export const schools: Record<string, string> = {
  1: 'sp 34',
};
export const classes: Record<string, string> = {
  1: '1a',
  2: '1b',
  3: '1c',
  4: '2a',
  5: '2b',
  6: '2c',
  7: '3a',
  8: '3b',
  9: '3c',
  10: '4a',
  11: '4b',
  12: '4c',
};

export const children: Record<string, string> = {
  1: 'Anna Nowak',
  2: 'Jan Kowalski',
  3: 'Krzysztof Krawczyk',
  4: 'Michał Wiśniewski',
  5: 'Patryk Kowal',
  6: 'Ewelina Czesak',
  7: 'Katarzyna Nosal',
  8: 'Patrycja Marchewka',
};

export const products: Record<string, string> = {
  1: 'Kalendarz starszy',
  2: 'Kalendarz młodszy',
  3: 'Zdjęcie w brązowej ramce',
  4: 'Zdjęcie w złotej ramce',
  5: 'Magnes',
};
